/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
var _excluded = ["list", "hasMore", "total"];

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import _regeneratorRuntime from "E:\\ysh\\wx-master\\node_modules\\_@babel_runtime@7.16.5@@babel\\runtime\\regenerator\\index.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
/*
 * @Description:
 * @Date: 2020-07-27 11:25:02
 */


export default {
  data: function data() {
    return {
      loading: true,
      hasMore: true,
      listData: [],
      pageQuery: {
        pageNo: 1,
        pageSize: 20
      },
      listAjax: null,
      listTotal: 0,
      listResultOtions: {}
    };
  },
  methods: {
    /**
     * @description: 接口调用，可外部覆盖
     * @return: 必须返回Promise并含有三个必有参数{list, hasMore, total, ...options}
     */
    listFunc: function () {
      var _listFunc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var query,
            _yield$this$listAjax,
            pdata,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.prev = 1;
                _context.next = 4;
                return this.listAjax(_objectSpread(_objectSpread({}, this.pageQuery), query));

              case 4:
                _yield$this$listAjax = _context.sent;
                pdata = _yield$this$listAjax.pdata;

                if (pdata.list) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", Promise.resolve({
                  list: pdata
                }));

              case 8:
                return _context.abrupt("return", Promise.resolve(pdata));

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                console.error(_context.t0);
                return _context.abrupt("return", Promise.reject());

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11]]);
      }));

      function listFunc() {
        return _listFunc.apply(this, arguments);
      }

      return listFunc;
    }(),

    /**
     * @description: 修改列表对应状态与调用列表方法
     * @param {type}
     * @return {type}
     */
    getList: function () {
      var _getList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
        var formatArgs, init, staticRefresh, _yield$this$listFunc, list, hasMore, total, options;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formatArgs = {
                  init: false,
                  staticRefresh: false
                };
                Object.assign(formatArgs, args);
                init = formatArgs.init, staticRefresh = formatArgs.staticRefresh;
                this.loading = true;

                if (init) {
                  !staticRefresh && (this.listData = []);
                  this.hasMore = true;
                  this.pageQuery.pageNo = 1;
                }

                _context2.prev = 5;
                _context2.next = 8;
                return this.listFunc(formatArgs);

              case 8:
                _yield$this$listFunc = _context2.sent;
                list = _yield$this$listFunc.list;
                hasMore = _yield$this$listFunc.hasMore;
                total = _yield$this$listFunc.total;
                options = _objectWithoutProperties(_yield$this$listFunc, _excluded);
                this.listData = staticRefresh && init ? list : this.listData.concat(list);
                this.pageQuery.pageNo += 1;
                this.hasMore = hasMore;
                this.listTotal = total;
                this.listResultOtions = options;
                _context2.next = 22;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](5);

              case 22:
                this.loading = false;

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 20]]);
      }));

      function getList(_x) {
        return _getList.apply(this, arguments);
      }

      return getList;
    }(),
    // 滑动
    preLoad: function () {
      var _preLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args) {
        var el, innerHeight, scrollTop, scrollHeight;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                el = document.querySelector('#listScroll') || this.$refs.listScroll || document.querySelector('body');
                innerHeight = el.clientHeight;
                scrollTop = Math.max(el.scrollTop || 0, document.documentElement.scrollTop || 0);
                scrollHeight = Math.max(el.clientHeight || 0, el.scrollHeight || 0);

                if (!(scrollTop / scrollHeight >= 0.6 && !this.loading && this.hasMore)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 7;
                return this.getList(args);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function preLoad(_x2) {
        return _preLoad.apply(this, arguments);
      }

      return preLoad;
    }()
  },
  watch: {},
  created: function created() {}
};